import React, { FC } from 'react';

import { Redirect as InternalRedirect } from '@reach/router';
import { withPrefix } from 'gatsby';
import { getInternalLink } from '@lucid/utils';

interface RedirectProps {
  passQueryParams?: boolean;
  to: string;
  siteDomain: string;
  blocklist?: string[];
}

const Redirect: FC<RedirectProps> = ({ to, passQueryParams, siteDomain, blocklist }) => {
  const link = getInternalLink({ link: to, siteDomain, blocklist });
  let params = '';
  if (passQueryParams) {
    params = window.location.search;
  }
  if (link !== null) {
    return <InternalRedirect noThrow to={withPrefix(`${link}${params}`)} />;
  }
  window.location.replace(`${to}${params}`);
  return <div />;
};

export default Redirect;
